import React from "react"
import styled from "styled-components"
import Boxed from "../../bits/box"
import FooterItems from "./footerItems"
import SiteLink from "../../bits/siteLink"
import Emoji from "../../bits/emoji"



const Container = styled.footer`
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(0,679,377)'%3E%3Cstop offset='0' stop-color='%23ffffff'/%3E%3Cstop offset='1' stop-color='%23fdfdfd'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='1762' height='1468.3' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.02'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
`

const FooterItem = styled(SiteLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: 2rem;
  font-family: var(--font-primary);
  color: var(--color-black);
  border-bottom: 0;
  text-align: center;
  &:last-child {
    margin-right: 0;
  }

  p {
    margin: 0;
    font-size: calc(18px + (20 - 18) * ((100vw - 320px) / (1600 - 320)));
    line-height: calc(32px + (40 - 32) * ((100vw - 320px) / (1600 - 320)));

    text-align: center;

    @media only screen and (max-width: 768px) {
      text-align: left;
    }
  }

  @media only screen and (max-width: 767px) {
    margin-right: 0;
    justify-content: left;
  }
`

const CreditText = styled.p`
  font-family: var(--font-secondary);
  font-size: 14px;
  line-height: 150%;
  color: var(--color-secondary-500);
`

const LinkContainer = styled.div`
  margin-top: 2rem;
  width: 100%;
  justify-content: center;
  display: flex;
  margin-top: 5px;

  @media only screen and (max-width: 767px) {
    display: grid;
    grid-gap: 16px;
    grid-template-columns: 1fr 1fr;
  }
`

const CreditContainer = styled.div`
  margin-top: 2rem;
  padding: var(--var-padding-xs);
  text-align: center;

  @media only screen and (max-width: 767px) {
    text-align: left;
  }
`

const TopRow = styled.section`
  padding: var(--var-padding-s) 1rem;

  @media only screen and (min-width: 767px) {
    padding-bottom: 0px;
  }
`

const BottomRow = styled.section`
  padding: var(--var-padding-s) 1rem;

  @media only screen and (min-width: 767px) {
    padding-top: 0px;
  }
`

const ISOContainer = styled.div`
  width: 120px;
`



const Footer = () => {
  return (
    <Container>
      <TopRow>
        <FooterItems />
      </TopRow>
      <BottomRow>
        <Boxed>
          <LinkContainer>
            <FooterItem className="noeffect" to="/">
              Home
            </FooterItem>
            <FooterItem className="noeffect" to="/about">
              About
            </FooterItem>
            <FooterItem className="noeffect" to="/blog">
              Blog
            </FooterItem>
            <FooterItem className="noeffect" to="/usecases">
              Use cases
            </FooterItem>
          </LinkContainer>
          <LinkContainer>
            <FooterItem className="noeffect" to="/privacy-policy">
              Privacy Policy
            </FooterItem>
            <FooterItem className="noeffect" to="/careers">
              Careers
            </FooterItem>
            <FooterItem className="noeffect" to="/download">
              Downloads
            </FooterItem>
          </LinkContainer>
          <LinkContainer>
            <ISOContainer>
              <img src="https://gecko-public.s3.eu-west-1.amazonaws.com/email-sigs/ISO27001.png" alt="ISO 27001"></img>
            </ISOContainer>
          </LinkContainer>

         
          <CreditContainer>
            <CreditText>
              Copyright © {new Date().getFullYear()} GECKO Governance <br />
              Built with &nbsp;
              <Emoji symbol="❤️" label="heart" />
              &nbsp; in &nbsp;
              <Emoji symbol="🇮🇪" label="Ireland" />
            </CreditText>
          </CreditContainer>
        </Boxed>
      </BottomRow>
    </Container>
  )
}

export default Footer
